import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import TableRowExport from 'component/Pdf/TableRowExport'
import { ExportProps } from 'features/report/report-constants'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { UseSnCode } from 'utils/useSnCode'
/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'

/** REPORT */

/** CONSTANTS */
import { getBranch, getSecureItem, numberFormat } from 'utils/app.utils'
import { dateTimeToView } from 'utils/date.utils'


/** STYLE */
import { KEY_STORAGE } from 'constants/common'
import * as UseStyled from 'features/report/useStyled'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import PaginationTable from 'new-components/pagination/pagination'
import { routeName } from 'routes/routes-name'


import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

export default function IncomeReport() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const componentRefExcel = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange
  const branchInfo: any = getSecureItem(KEY_STORAGE.CLINIC_INFO)

  const [loading, setLoading] = useState<boolean>(true)
  const [openInfo, setOpenInfo] = useState<boolean>(false)

  const [branches, setBranches] = useState<any[]>([])
  const [branchId, setBranchId] = useState<any>(getBranch())
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
  const [receiptPrefix, setReceiptPrefix] = useState<any[]>([])
  const [prefix, setPrefix] = useState<string>('ALL')

  const [incomePage, setIncomePage] = useState<number>(1)
  const [incomePageLimit, setIncomePageLimit] = useState<number>(10)
  const [incomeRowCount, setIncomeRowCount] = useState<number>(0)
  const [incomeSortBy, setIncomeSortBy] = useState<string>('createAt')
  const [incomeSortType, setIncomeSortType] = useState<string>('ASC')
  const [incomeData, setIncomeData] = useState<any[]>([])
  const [incomeExport, setIncomeExportData] = useState<any[]>([])

  const [incomeTypePage, setIncomeTypePage] = useState<number>(1)
  const [incomeTypePageLimit, setIncomeTypePageLimit] = useState<number>(10)
  const [incomeTypeRowCount, setIncomeTypeRowCount] = useState<number>(0)
  const [incomeTypeSortBy, setIncomeTypeSortBy] = useState<string>('createAt')
  const [incomeTypeSortType, setIncomeTypeSortType] = useState<string>('ASC')
  const [incomeTypeData, setIncomeTypeData] = useState<any[]>([])
  const [incomeTypeExport, setIncomeTypeExportData] = useState<any[]>([])

  const [incomeOverduePage, setIncomeOverduePage] = useState<number>(1)
  const [incomeOverduePageLimit, setIncomeOverduePageLimit] = useState<number>(10)
  const [incomeOverdueRowCount, setIncomeOverdueRowCount] = useState<number>(0)
  const [incomeOverdueSortBy, setIncomeOverdueSortBy] = useState<string>('')
  const [incomeOverdueSortType, setIncomeOverdueSortType] = useState<string>('')
  const [incomeOverdueData, setIncomeOverdueData] = useState<any[]>([])
  const [incomeOverdueExport, setIncomeOverdueExportData] = useState<any[]>([])

  const [billStatus, setBillStatus] = useState<string>('ALL')


  const optionPaymentChanel = [
    { name: t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.CASH'), id: 1, },
    { name: t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.TRANSFER'), id: 2, },
    { name: t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.CREDIT'), id: 3, },
    { name: t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.DEBIT'), id: 4, },
    { name: t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.TREATMENTRIGHT'), id: 5, },
    { name: t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.ADVANCE'), id: 6, },
    { name: t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.VOUCHER'), id: 7, },
    { name: t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.PROMOTION'), id: 8, }
  ]
  const [paymentChanelSelect, setPaymentChanelSelect] = useState<number[]>(optionPaymentChanel.map((item) => item.id))

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    ReportApi.reportList(condition).then(({ data }) => {
      const check = _.find(data, (val: any) => String(val.reportKey) === 'INCOME_SIMPLE_DAILY') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })

    /** MASTER DATA */
    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(_.map(data, (item) => ({ value: item.branchId, name: item.branchName || item.branchNameEn }))))
      .catch((e) => {
        return
      })

    ClinicApi.allBillPrefix()
      .then(({ data }) => {
        const filteredData = data.map((item: any) => ({ value: item.prefix, name: item.prefix }))
        setReceiptPrefix([...filteredData, { value: 'AD', name: 'AD' }])
      })
      .catch((e) => {
        return
      })

    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [])

  /** TABLE 1 */
  const fetchIncome = () => {
    let condition: FindAllReportInterface = {
      page: incomePage,
      pageLimit: incomePageLimit,
      branchId: branchId,
      prefix: prefix
    }
    if (billStatus && billStatus !== 'ALL') condition = { ...condition, status: billStatus }
    if (incomeSortType) condition = { ...condition, sortType: incomeSortType }
    if (incomeSortBy) condition = { ...condition, sortBy: incomeSortBy }
    if (paymentChanelSelect?.length) condition = { ...condition, paymentChanel: paymentChanelSelect.join(',') }

    if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }

    ReportApi.reportIncomeSimpleDaily(condition)
      .then(({ headers, data }) => {
        setIncomeData(data)
        setIncomeRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }
  // branchId, rangeDate, prefix, billStatus

  const onChangeIncomeSort = (sortByVal: string, sortTypeVal: string) => {
    setIncomeSortType(sortTypeVal)
    setIncomeSortBy(sortByVal)
  }

  const onChangeIncomeRowPerPage = (event: any) => {
    setIncomePageLimit(parseInt(event.target.value, 10))
  }

  const onChangeIncomePage = (val: number, newPage: number) => {
    setIncomePage(newPage)
  }


  const loadIncomeExport = useCallback(async () => {
    let condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 1000,
      branchId: branchId,
      prefix: prefix,
      export: 1
    }

    if (billStatus && billStatus !== 'ALL') condition = { ...condition, status: billStatus }
    if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    if (paymentChanelSelect?.length) condition = { ...condition, paymentChanel: paymentChanelSelect.join(',') }

    ReportApi.reportIncomeSimpleDaily(condition)
      .then(({ data }) => {
        setIncomeExportData(data)
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }, [branchId, rangeDate, prefix, billStatus, paymentChanelSelect])

  /** TABLE 2 */
  const fetchIncomeType = () => {
    let condition: FindAllReportInterface = {
      page: incomeTypePage,
      pageLimit: incomeTypePageLimit,
      branchId: branchId,
      prefix: prefix
    }
    if (billStatus && billStatus !== 'ALL') condition = { ...condition, status: billStatus }
    if (incomeTypeSortType) condition = { ...condition, sortType: incomeTypeSortType }
    if (incomeTypeSortBy) condition = { ...condition, sortBy: incomeTypeSortBy }
    if (paymentChanelSelect?.length) condition = { ...condition, paymentChanel: paymentChanelSelect.join(',') }

    if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }

    ReportApi.reportIncomeTypeDaily(condition)
      .then(({ headers, data }) => {
        /** TOTAL */
        const total = {
          paidCancel: 0,
          paidNormal: 0,
          cardTypeName: null,
          paymentChannelName: t('REPORT.TITLE.SUM')
        }

        data.map((t: any) => {
          total.paidCancel += t.paidCancel
          total.paidNormal += t.paidNormal
        })
        setIncomeTypeData(data.concat(total))
        setIncomeTypeRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }

  const onChangeIncomeTypeSort = (sortByVal: string, sortTypeVal: string) => {
    setIncomeTypeSortType(sortTypeVal)
    setIncomeTypeSortBy(sortByVal)
  }

  const onChangeIncomeTypeRowPerPage = (limit: number) => {
    setIncomeTypePageLimit(limit)
  }

  const onChangeIncomeTypePage = (val: number) => {
    setIncomeTypePage(val)
  }

  const loadIncomeTypeExport = useCallback(async () => {
    let condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 1000,
      branchId: branchId,
      prefix: prefix
    }
    if (billStatus && billStatus !== 'ALL') condition = { ...condition, status: billStatus }
    if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    if (paymentChanelSelect?.length) condition = { ...condition, paymentChanel: paymentChanelSelect.join(',') }

    ReportApi.reportIncomeTypeDaily(condition)
      .then(({ headers, data }) => {
        /** TOTAL */
        const total = {
          paidCancel: 0,
          paidNormal: 0,
          cardTypeName: null,
          paymentChannelName: t('REPORT.TITLE.SUM')
        }

        data.map((t: any) => {
          total.paidCancel += t.paidCancel
          total.paidNormal += t.paidNormal
        })
        setIncomeTypeExportData(data.concat(total))
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }, [branchId, rangeDate[1], prefix, paymentChanelSelect])

  /** TABLE 3 */
  const fetchIncomeOverdue = () => {
    let condition: FindAllReportInterface = {
      page: incomeTypePage,
      pageLimit: incomeTypePageLimit,
      branchId: branchId,
      prefix: prefix
    }
    if (billStatus && billStatus !== 'ALL') condition = { ...condition, status: billStatus }
    if (incomeTypeSortType) condition = { ...condition, sortType: incomeTypeSortType }
    if (incomeTypeSortBy) condition = { ...condition, sortBy: incomeTypeSortBy }
    if (paymentChanelSelect?.length) condition = { ...condition, paymentChanel: paymentChanelSelect.join(',') }

    if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }

    ReportApi.reportIncomeOverdueDaily(condition)
      .then(({ headers, data }) => {
        setIncomeOverdueData(data)
        setIncomeOverdueRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }

  const loadIncomeOverdueExport = useCallback(async () => {
    let condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 1000,
      branchId: branchId,
      prefix: prefix
    }
    if (billStatus && billStatus !== 'ALL') condition = { ...condition, status: billStatus }
    if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }

    ReportApi.reportIncomeOverdueDaily(condition)
      .then(({ data }) => {
        setIncomeOverdueExportData(data)
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }, [branchId, rangeDate[1], prefix, billStatus])

  /** UseEffect */
  useEffect(() => {
    fetchIncome()
  }, [incomePage, incomePageLimit, incomeSortType, incomeSortBy])

  useEffect(() => {
    fetchIncomeType()
    fetchIncomeOverdue()
  }, [])

  useEffect(() => {
    loadIncomeExport()
    loadIncomeTypeExport()
    loadIncomeOverdueExport()
  }, [loadIncomeExport, loadIncomeTypeExport, loadIncomeOverdueExport])


  const toBuddhistYear = (date: moment.MomentInput, format = 'DD/MM/YYYY') => {
    return moment(date).add(543, 'years').format(format);
  };



  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('รายงานสรุปรายได้');

    // --- Styling Constants ---
    const titleFont = { bold: true, size: 14 };
    const filterFont = { size: 10 };
    const sectionTitleFont = { bold: true, size: 12 };
    const headerFont = { bold: true, size: 10 };
    const dataFont = { size: 9.5 };
    const topAlign = { vertical: 'top' as const };
    const thinBorder = {
      top: { style: 'thin' as const },
      left: { style: 'thin' as const },
      bottom: { style: 'thin' as const },
      right: { style: 'thin' as const }
    };

    const applyThinBorder = (row: ExcelJS.Row) => {
      row.eachCell((cell) => {
        cell.border = thinBorder;
      });
    };

    // --- Main Title ---
    const titleRow = sheet.addRow(['รายงานสรุปรายได้']);
    titleRow.font = titleFont;
    const maxColumn = snType ? 'P' : 'O';
    sheet.mergeCells(`A1:${maxColumn}1`);

    // --- Filters ---
    const dateStart = rangeDate[0] ? toBuddhistYear(moment(rangeDate[0]), 'DD/MM/YYYY') : '-';
    const dateEnd = rangeDate[1] ? toBuddhistYear(moment(rangeDate[1]), 'DD/MM/YYYY') : '-';
    const filterText = `${t('REPORT.TABLE.DECREASE.BRANCH')}: ${_.find(branches, b => b.value === branchId)?.name || '-'}  ${t('สถานะใบเสร็จ')}: ${billStatus === 'ALL' ? 'ทั้งหมด' : t(`REPORT.FILTER.BILL.${billStatus}`)}   ${t('ประเภทใบเสร็จ')}: ${prefix === 'ALL' ? 'ทั้งหมด' : prefix}   ${t('REPORT.TABLE.DECREASE.DATE_START')}: ${dateStart}  ${t('REPORT.TABLE.DECREASE.DATE_END')}: ${dateEnd}`;

    const filtersRow = sheet.addRow([filterText]);
    filtersRow.font = filterFont;
    sheet.mergeCells(filtersRow.number, 1, filtersRow.number, snType ? 16 : 15);

    sheet.addRow([]); // Spacer

    // --- Table 1: Income Details ---
    const incomeTableColumns = [
      { header: t('REPORT.TABLE.INCOME_DAY.BILL_ID'), width: 20, align: 'left' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.DATE_TIME'), width: 20, align: 'left' as const },
      { header: t('APPLICATION.TABLE.CELL.CN_NUMBER'), width: 15, align: 'left' as const },
      { header: t('PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID'), width: 15, align: 'left' as const },
      ...(snType ? [{ header: t('PATIENT_MANAGEMENT.TABLE.CELL.SN_CODE'), width: 15, align: 'left' as const }] : []),
      { header: t('REPORT.TABLE.INCOME_DAY.PATIENT_NAME'), width: 30, align: 'left' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.PATIENT_AGE'), width: 10, align: 'right' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.PAYMENT_STATUS'), width: 15, align: 'left' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.PAYMENT_CHANNELS'), width: 25, align: 'left' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.PAYMENT_PAY'), width: 15, align: 'right' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.PAYMENT_OVERDUE'), width: 15, align: 'right' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.REMARK'), width: 30, align: 'left' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.CREATED_BY'), width: 20, align: 'left' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.REMARK_CANCEL'), width: 30, align: 'left' as const },
      { header: t('REPORT.TABLE.INCOME_DAY.CANCEL_BY'), width: 20, align: 'left' as const },
    ];

    sheet.columns = incomeTableColumns.map(c => ({ width: c.width }));

    const incomeHeaderRow = sheet.addRow(incomeTableColumns.map(c => c.header));
    incomeHeaderRow.font = headerFont;
    applyThinBorder(incomeHeaderRow);
    incomeHeaderRow.eachCell((cell, colNumber) => {
      const align = incomeTableColumns[colNumber - 1]?.align || 'center';
      cell.alignment = { horizontal: align, vertical: 'middle' };
    });

    incomeExport.forEach((d: any) => {
      const rowData = [
        d.billNo,
        dateTimeToView(d.paidAt),
        d.cnNumber || '-',
        d.branchCnNumber || '-',
        ...(snType ? [d.snCode || '-'] : []),
        d.patientFullname || '-',
        d.age || '-',
        t(`REPORT.BILL_STATUS.${d.billStatus}`),
        d.paymentChannel || '-',
        d.amountPaid,
        d.overdue,
        d.remark || '-',
        d.createdBy || '-',
        d.cancelRemark || '-',
        d.cancelBy || '-'
      ];

      const dataRow = sheet.addRow(rowData);
      dataRow.font = dataFont;

      const amountPaidColIndex = snType ? 9 : 8;
      const overdueColIndex = snType ? 10 : 9;
      dataRow.getCell(amountPaidColIndex + 1).numFmt = '#,##0.00';
      dataRow.getCell(overdueColIndex + 1).numFmt = '#,##0.00';

      dataRow.eachCell((cell, colNumber) => {
        const columnConfig = incomeTableColumns[colNumber - 1];
        cell.alignment = {
          vertical: 'top',
          horizontal: columnConfig?.align || 'left'
        };
      });

      applyThinBorder(dataRow);
    });

    sheet.addRow([]); // Spacer

    // --- Table 2: Payment Summary ---
    const paymentTitleRow = sheet.addRow(['ยอดชำระเงิน']);
    paymentTitleRow.font = sectionTitleFont;
    applyThinBorder(paymentTitleRow);

    const paymentHeaderRow = sheet.addRow([t('REPORT.TABLE.INCOME_DAY.TYPE_OF_PAYMENT'), t('REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME'), t('REPORT.TABLE.INCOME_DAY.SUMMARY_CANCEL')]);
    paymentHeaderRow.font = headerFont;
    paymentHeaderRow.getCell(1).alignment = { horizontal: 'left' };
    paymentHeaderRow.getCell(2).alignment = { horizontal: 'right' };
    paymentHeaderRow.getCell(3).alignment = { horizontal: 'right' };
    applyThinBorder(paymentHeaderRow);

    incomeTypeExport.forEach((d: any) => {
      const name = d.paymentChannelName === 'Voucher'
        ? `${t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.VOUCHER')}${d.cardTypeName ? ` (${d.cardTypeName})` : ''}`
        : d.paymentChannelName;
      const row = sheet.addRow([
        name,
        d.paidNormal,
        d.paidCancel
      ]);
      row.getCell(2).numFmt = '#,##0.00';
      row.getCell(3).numFmt = '#,##0.00';
      row.getCell(2).alignment = { horizontal: 'right' };
      row.getCell(3).alignment = { horizontal: 'right' };
      applyThinBorder(row);
    });

    sheet.addRow([]); // Spacer

    // --- Table 3: Other Items ---
    const otherTitleRow = sheet.addRow(['รายการอื่นๆ']);
    otherTitleRow.font = sectionTitleFont;
    applyThinBorder(otherTitleRow);

    const otherHeaderRow = sheet.addRow([t('REPORT.TABLE.INCOME_DAY.LIST'), t('REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME'), t('REPORT.TABLE.INCOME_DAY.SUMMARY_CANCEL')]);
    otherHeaderRow.font = headerFont;
    otherHeaderRow.getCell(1).alignment = { horizontal: 'left' };
    otherHeaderRow.getCell(2).alignment = { horizontal: 'right' };
    otherHeaderRow.getCell(3).alignment = { horizontal: 'right' };
    applyThinBorder(otherHeaderRow);

    incomeOverdueData.forEach((d: any) => {
      const row = sheet.addRow([
        d.paymentChannelName || '-',
        d.paidNormal,
        d.paidCancel
      ]);
      row.getCell(2).numFmt = '#,##0.00';
      row.getCell(3).numFmt = '#,##0.00';
      row.getCell(2).alignment = { horizontal: 'right' };
      row.getCell(3).alignment = { horizontal: 'right' };
      applyThinBorder(row);
    });

    sheet.addRow([]); // Spacer

    // --- Summary ---
    const netIncomeTitleRow = sheet.addRow(['ยอดรายได้สุทธิ']);
    netIncomeTitleRow.font = sectionTitleFont;
    applyThinBorder(netIncomeTitleRow);

    const totalRow = sheet.addRow(['รวม', sum]);
    totalRow.getCell(2).numFmt = '#,##0.00';
    totalRow.getCell(2).alignment = { horizontal: 'right' };
    applyThinBorder(totalRow);


    // --- File Saving ---
    const buffer = await workbook.xlsx.writeBuffer();
    const timestamp = moment().format('YYYYMMDD');
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `รายงานสรุปรายได้_${timestamp}.xlsx`);
  };

  const [snType, setSnType] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])

  const onLoadData = () => {
    fetchIncome()
    fetchIncomeType()
    fetchIncomeOverdue()
    loadIncomeExport()
    loadIncomeTypeExport()
    loadIncomeOverdueExport()
  }

  const calculateAdvance = JSON.parse(branchInfo)?.calculateAdvance
  const isIncrease = calculateAdvance === "INCREASE"
  let sum = 0
  _.map(incomeExport, (o: any) => {
    if (isIncrease) {
      if (o.billStatus === 'CANCEL') {
        sum -= Number(o.amountPaid)
      }
      sum += Number(o.amountPaid) - Number(o.amountAdvance)
    } else {
      if (o.type === "ORDER_PAYMENT") {
        sum += Number(o.amountPaid)
        if (o.billStatus === 'CANCEL') {
          sum -= Number(o.amountPaid)
        }
      }
    }
  })

  return (
    <Box>
      <HeaderCard
        text={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {t(`REPORT.REPORT_NAME.INCOME_SIMPLE_DAILY`)}
            <Box
              onClick={() => setOpenInfo(true)}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1.25,
                py: 0.5,
                ml: 1,
                cursor: 'pointer',
                color: '#2F4269',
                backgroundColor: 'rgba(47, 66, 105, 0.08)',
                borderRadius: '999px',
                fontSize: '14px',
                fontWeight: 500,
                transition: 'background-color 0.15s ease',
                '&:hover': {
                  backgroundColor: 'rgba(47, 66, 105, 0.16)'
                }
              }}
              role="button"
              aria-label={t('REPORT.TABLE.INCOME_DAY.NOTE_TITLE')}
            >
              <FontAwesomeIcon icon={faQuestionCircle} style={{ fontSize: 16 }} />
              <Box component="span">{t('คำอธิบายรายงาน')}</Box>
            </Box>
          </Box>
        }
      />
      <Box padding="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(e) => {
                setBranchId(e.target.value)
                setIncomePage(1)
                setIncomeTypePage(1)
              }}
              options={branches}
              value={branchId}
              defaultValue={branches?.[0]?.branchId}
              label={t('REPORT.FILTER.BRANCH')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(e) => {
                setPrefix(e.target.value)
                setIncomePage(1)
                setIncomeTypePage(1)
              }}
              options={[{ value: 'ALL', name: t('REPORT.FILTER.ALL') }, ...receiptPrefix]}
              value={prefix}
              label={t('REPORT.FILTER.RECEIPT_TYPE')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(e) => {
                setBillStatus(e.target.value)
                setIncomeTypePage(1)
              }}
              options={[
                { value: 'ALL', name: t('REPORT.FILTER.ALL') },
                { value: 'PAID', name: t('REPORT.FILTER.BILL.PAID') },
                { value: 'CANCEL', name: t('REPORT.FILTER.BILL.CANCEL') },
                { value: 'OVERDUE', name: t('REPORT.FILTER.BILL.OVERDUE') },
              ]}
              value={billStatus}
              label={t('REPORT.FILTER.RECEIPT_STATUS')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectCheckBoxInput
              label={t("PAYMENT_DETAIL.LABEL.PAYMENT_CHANNEL")}
              onChange={setPaymentChanelSelect}
              options={optionPaymentChanel}
              selected={paymentChanelSelect}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <InputSecondNewRangePicker
              inputHeight={40}
              value={rangeDate || emptyRangePicker}
              onchange={(val: any) => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                setIncomePage(1)
                setIncomeTypePage(1)
              }}
              label={`${t('REPORT.TABLE.DECREASE.DATE_START')} » ${t('REPORT.TABLE.DECREASE.DATE_END')}`}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={9} xl={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
              <MainButton
                title={t('INPUT.SEARCH')}
                onClick={() => {
                  setIncomePage(1)
                  onLoadData()
                }}
                type={'primary'}
                variant={'contained'}
                style={{ width: '120px' }}
              />
              <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                if (e === 'Excel') exportToExcel()
                if (e === 'PDF') {
                  const style = document.createElement("style");
                  style.innerHTML = `
                      @media print {
                        @page { size: landscape }
                      }
                    `;
                  document.head.appendChild(style);
                  window.print();
                  document.head.removeChild(style);

                }
              }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ overflowX: 'auto', overflowY: 'hidden', marginTop: '16px' }}>
          <TableContainer style={{ boxShadow: 'none', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
            <Table aria-label="simple table" sx={{ width: '100%' }}>
              <TableHead sx={{ backgroundColor: "#2F4269", color: 'white', border: '1px solid #2F4269' }}>
                <TableRow>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '200px' }}>{t('REPORT.TABLE.INCOME_DAY.BILL_ID')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '200px' }}>{t('REPORT.TABLE.INCOME_DAY.DATE_TIME')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px' }}>{t('APPLICATION.TABLE.CELL.CN_NUMBER')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '150px' }}>{t('PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID')}</TableCell>
                  {snType && <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '125px' }}>{t('PATIENT_MANAGEMENT.TABLE.CELL.SN_CODE')}</TableCell>}
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '250px' }}>{t('REPORT.TABLE.INCOME_DAY.PATIENT_NAME')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px' }}>{t('REPORT.TABLE.INCOME_DAY.PATIENT_AGE')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px' }}>{t('REPORT.TABLE.INCOME_DAY.PAYMENT_STATUS')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '250px' }}>{t('REPORT.TABLE.INCOME_DAY.PAYMENT_CHANNELS')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px' }}>{t('REPORT.TABLE.INCOME_DAY.PAYMENT_PAY')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '150px' }}>{t('REPORT.TABLE.INCOME_DAY.PAYMENT_OVERDUE')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '250px' }}>{t('REPORT.TABLE.INCOME_DAY.REMARK')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '200px' }}>{t('REPORT.TABLE.INCOME_DAY.CREATED_BY')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '250px' }}>{t('REPORT.TABLE.INCOME_DAY.REMARK_CANCEL')}</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '200px' }}>{t('REPORT.TABLE.INCOME_DAY.CANCEL_BY')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {incomeData.map((data, index) => (
                  <TableRow key={index} style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.billNo}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{dateTimeToView(data?.paidAt)}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.cnNumber || "-"}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.branchCnNumber || "-"}</TableCell>
                    {snType && <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.snCode || "-"}</TableCell>}
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.patientFullname || "-"}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'center' }}>{data?.age || "-"}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'center' }}>{t(`REPORT.BILL_STATUS.${data.billStatus}`)}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.paymentChannel || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'end' }}>{numberFormat(data.amountPaid) || '0.00'}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'end' }}>{numberFormat(data?.overdue) || '0.00'}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.remark || "-"}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.createdBy || "-"}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.cancelRemark || "-"}</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.cancelBy || "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box marginTop="8px">
          <PaginationTable
            onChange={onChangeIncomePage}
            onPerPageChange={onChangeIncomeRowPerPage}
            page={incomePage}
            perPage={incomePageLimit}
            totalPage={incomeRowCount}
          />
        </Box>
        <Box border={1} borderColor="#E5E5E5" width="100%" marginY="32px" />
        {/* <Divider sx={{ backgroundColor: "#E5E5E5", opacity: 1, borderColor: '#E5E5E5 !important', marginY: '32px', width: '100%', marginX: 0 }} /> */}

        <Box display="flex" flexDirection="row" gap="16px" width="100%">
          <Box display="flex" flexDirection="column" gap="8px" width="35%">
            <Typography fontSize="20px">ยอดชำระเงิน</Typography>
            <TableContainer style={{ boxShadow: 'none', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
              <Table aria-label="simple table" sx={{ width: '100%' }}>
                <TableHead sx={{ backgroundColor: "#2F4269", color: 'white', border: '1px solid #2F4269' }}>
                  <TableRow>
                    <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '200px' }}>{t('REPORT.TABLE.INCOME_DAY.TYPE_OF_PAYMENT')}</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px', textAlign: 'end' }}>{t('REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME')}</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px', textAlign: 'end' }}>{t('REPORT.TABLE.INCOME_DAY.SUMMARY_CANCEL')}</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {incomeTypeData.map((data, index) => (
                    <TableRow key={index} style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                      <TableCell sx={{
                        fontSize: '16px', fontWeight: 400,
                      }}>{`${data.paymentChannelName === 'Voucher' ? t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.VOUCHER') : data.paymentChannelName}${data.cardTypeName !== null ? `/${data.cardTypeName}` : ``}`}</TableCell>
                      <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'end' }}>{numberFormat(data.paidNormal) || "-"}</TableCell>
                      <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'end' }}>{numberFormat(data.paidCancel) || "-"}</TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box display="flex" flexDirection="column" gap="8px" width="35%">
            <Typography fontSize="20px">รายการอื่นๆ</Typography>
            <TableContainer style={{ boxShadow: 'none', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
              <Table aria-label="simple table" sx={{ width: '100%' }}>
                <TableHead sx={{ backgroundColor: "#2F4269", color: 'white', border: '1px solid #2F4269' }}>
                  <TableRow>
                    <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '200px' }}>{t('REPORT.TABLE.INCOME_DAY.LIST')}</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px', textAlign: 'end' }}>{t('REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME')}</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px', textAlign: 'end' }}>{t('REPORT.TABLE.INCOME_DAY.SUMMARY_CANCEL')}</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {incomeOverdueData.map((data, index) => (
                    <TableRow key={index} style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                      <TableCell sx={{
                        fontSize: '16px', fontWeight: 400,
                      }}>{data.paymentChannelName || '-'}</TableCell>
                      <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'end' }}>{numberFormat(data.paidNormal) || "-"}</TableCell>
                      <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'end' }}>{numberFormat(data.paidCancel) || "-"}</TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
        <Typography fontSize='20px' marginBottom="8px" marginTop="16px" >ยอดรายได้สุทธิ</Typography>
        <TableContainer style={{ boxShadow: 'none', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
          <Table aria-label="simple table" sx={{ width: '30%' }}>
            <TableHead sx={{ backgroundColor: "#2F4269", color: 'white', border: '1px solid #2F4269' }}>
              <TableRow>
                <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '200px' }}>{'#'}</TableCell>
                <TableCell sx={{ color: "white", fontWeight: 500, minWidth: '100px', textAlign: 'end' }}>{t('REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                <TableCell sx={{ fontSize: '16px', fontWeight: 400, }}>{'รวม'}</TableCell>
                <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'end' }}>{numberFormat(sum) || "-"}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          open={openInfo}
          onClose={() => setOpenInfo(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: '8px' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: 'rgba(47, 66, 105, 0.04)',
              borderLeft: '4px solid #2F4269',
              py: 1.5
            }}
          >
            <Typography fontSize="16px" fontWeight={600} color="#2F4269">
              {t('REPORT.TABLE.INCOME_DAY.NOTE_TITLE')}
            </Typography>
            <IconButton onClick={() => setOpenInfo(false)} size="small" sx={{ p: 0 }}>
              <CloseIcon sx={{ width: '24px', height: '24px', color: '#808080' }} />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2, pb: 3 }}>
            <Box display="flex" flexDirection="column" gap={1} mt={2}>
              <Typography fontSize="14px" fontWeight={400} color="#666666" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <span style={{ fontSize: '10px', marginTop: '4px' }}>•</span>
                <span>{t('REPORT.TABLE.INCOME_DAY.NOTE_LINE_1')}</span>
              </Typography>
              <Typography fontSize="14px" fontWeight={400} color="#666666" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <span style={{ fontSize: '10px', marginTop: '4px' }}>•</span>
                <span>{t('REPORT.TABLE.INCOME_DAY.NOTE_LINE_2')}</span>
              </Typography>
              <Typography fontSize="14px" fontWeight={400} color="#666666" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <span style={{ fontSize: '10px', marginTop: '4px' }}>•</span>
                <span>{t('REPORT.TABLE.INCOME_DAY.NOTE_LINE_3')}</span>
              </Typography>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
      <Box id="print-table-container" ref={componentRef}>
        <Typography fontSize="14px" fontWeight={400}>รายงานสรุปรายได้</Typography>
        <Box gap="16px" display="flex" flexDirection="row" marginTop="16px" whiteSpace="nowrap">
          <Box display="flex" flexDirection="row" marginBottom="16px">
            <Typography fontSize="9.5px" fontWeight={700}>{t('REPORT.FILTER.BRANCH')}: </Typography>
            <Typography fontSize="9.5px">{_.find(branches, (item) => item.value === branchId)?.name}</Typography>
          </Box>
          <Box display="flex" flexDirection="row" fontSize="9.5px">
            <Typography fontSize="9.5px" fontWeight={700}>{t('REPORT.FILTER.RECEIPT_STATUS')}: </Typography>
            <Typography fontSize="9.5px">{billStatus === 'ALL' ? t(`REPORT.FILTER.ALL`) : t(`REPORT.FILTER.BILL.${billStatus}`)}</Typography>
          </Box>
          <Box display="flex" flexDirection="row" fontSize="9.5px">
            <Typography fontSize="9.5px" fontWeight={700}>{t('REPORT.FILTER.RECEIPT_TYPE')}: </Typography>
            <Typography fontSize="9.5px">{prefix === 'ALL' ? t(`REPORT.FILTER.ALL`) : prefix}</Typography>
          </Box>
          <Box display="flex" flexDirection="row" fontSize="9.5px">
            <Typography fontSize="9.5px" fontWeight={700}>{t('REPORT.FILTER.START')}</Typography>
            <Typography fontSize="9.5px">{rangeDate[0] ? toBuddhistYear(moment(rangeDate[0]), 'DD/MM/YYYY') : '-'}</Typography>
            <Typography fontSize="9.5px" fontWeight={700}>{t('REPORT.FILTER.DATE_END')}</Typography>
            <Typography fontSize="9.5px">{rangeDate[1] ? toBuddhistYear(moment(rangeDate[1]), 'DD/MM/YYYY') : '-'}</Typography>
          </Box>
        </Box>
        <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', }}>
          <thead>
            <tr style={{ fontSize: '9.5px', fontWeight: 700 }}>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.BILL_ID')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }} >{t('REPORT.TABLE.INCOME_DAY.DATE_TIME')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('APPLICATION.TABLE.CELL.CN_NUMBER')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID')}</th>
              {snType && <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('PATIENT_MANAGEMENT.TABLE.CELL.SN_CODE')}</th>}
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.PATIENT_NAME')}</th>
              <th style={{ textAlign: 'right', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.PATIENT_AGE')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.PAYMENT_STATUS')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.PAYMENT_CHANNELS')}</th>
              <th style={{ textAlign: 'right', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.PAYMENT_PAY')}</th>
              <th style={{ textAlign: 'right', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.PAYMENT_OVERDUE')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.REMARK')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.CREATED_BY')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.REMARK_CANCEL')}</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.CANCEL_BY')}</th>
            </tr>
          </thead>
          <tbody>
            {incomeExport.map((data: any, index: number) => (
              <tr key={index}>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', width: '125px', verticalAlign: 'top' }}>{data?.billNo}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', width: '85px', verticalAlign: 'top' }}>{dateTimeToView(data?.paidAt)}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data?.cnNumber || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data?.branchCnNumber || '-'}</td>
                {snType && <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data?.snCode || '-'}</td>}
                <td style={{ fontSize: '9.5px', fontWeight: 500, width: '120px', textAlign: 'left', verticalAlign: 'top' }}>{data?.patientFullname || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top' }}>{data?.age || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', width: '50px', verticalAlign: 'top' }}>{t(`REPORT.BILL_STATUS.${data.billStatus}`)}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data?.paymentChannel || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top' }}>{numberFormat(data.amountPaid) || '0.00'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top' }}>{numberFormat(data?.overdue) || '0.00'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data?.remark || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data?.createdBy || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data?.cancelRemark || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data?.cancelBy || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <br></br>

        <Box display="flex" flexDirection="row" gap="16px" height={'auto'} className="page-break-inside">
          <Box style={{ padding: 0, margin: 0 }} >
            <Typography fontSize="14px" fontWeight={400}>ยอดชำระเงิน</Typography>
            <table style={{ borderCollapse: 'separate', borderSpacing: 0, border: '1px solid black' }}>
              <thead>
                <tr style={{ fontSize: '9.5px', fontWeight: 700 }}>
                  <th style={{ textAlign: 'left', borderBottom: '1px solid black' }}>{t('REPORT.TABLE.INCOME_DAY.TYPE_OF_PAYMENT')}</th>
                  <th style={{ textAlign: 'end', borderBottom: '1px solid black', paddingTop: '6px', paddingBottom: '6px' }} >{t('REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME')}</th>
                  <th style={{ textAlign: 'end', borderBottom: '1px solid black', paddingTop: '6px', paddingBottom: '6px' }}>{t('REPORT.TABLE.INCOME_DAY.SUMMARY_CANCEL')}</th>
                </tr>
              </thead>
              <tbody>
                {incomeTypeExport.map((data: any, index: number) => (
                  <tr key={index} >
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left' }}>{`${data.paymentChannelName === 'Voucher' ? t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.VOUCHER') : data.paymentChannelName} ${data.cardTypeName !== null ? `(${data.cardTypeName})` : ``}`}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, paddingTop: '6px', paddingBottom: '6px', textAlign: 'end', width: '75px' }}>{numberFormat(data.paidNormal) || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, paddingTop: '6px', paddingBottom: '6px', width: '75px', textAlign: 'end' }}>{numberFormat(data.paidCancel) || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>

          <Box style={{ padding: 0, margin: 0 }}>
            <Typography fontSize="14px" fontWeight={400}>รายการอื่นๆ</Typography>
            <table style={{ borderCollapse: 'separate', borderSpacing: 0, border: '1px solid black' }}>
              <thead>
                <tr style={{ fontSize: '9.5px', fontWeight: 700 }}>
                  <th style={{ textAlign: 'left', borderBottom: '1px solid black', }}>{t('REPORT.TABLE.INCOME_DAY.LIST')}</th>
                  <th style={{ textAlign: 'end', borderBottom: '1px solid black', paddingTop: '6px', paddingBottom: '6px' }} >{t('REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME')}</th>
                  <th style={{ textAlign: 'end', borderBottom: '1px solid black', paddingTop: '6px', paddingBottom: '6px' }}>{t('REPORT.TABLE.INCOME_DAY.SUMMARY_CANCEL')}</th>
                </tr>
              </thead>
              <tbody>
                {incomeOverdueData.map((data: any, index: number) => (
                  <tr key={index}>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, paddingTop: '6px', paddingBottom: '6px', textAlign: 'left' }}>{data?.paymentChannelName || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, paddingTop: '6px', paddingBottom: '6px', textAlign: 'end', width: '75px' }}>{numberFormat(data.paidNormal) || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, paddingTop: '6px', paddingBottom: '6px', width: '75px', textAlign: 'end' }}>{numberFormat(data.paidCancel) || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
        <br />
        <Box style={{ padding: 0, margin: 0 }}>
          <Typography fontSize="14px" fontWeight={400}>ยอดรายได้สุทธิ</Typography>
          <table style={{ borderCollapse: 'separate', borderSpacing: 0, border: '1px solid black' }}>
            <thead>
              <tr style={{ fontSize: '9.5px', fontWeight: 700 }}>
                <th style={{ textAlign: 'left', borderBottom: '1px solid black', padding: '6px' }}>{t('#')}</th>
                <th style={{ textAlign: 'end', borderBottom: '1px solid black', paddingTop: '6px', paddingBottom: '6px', minWidth: '300px' }} >{t('REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ fontSize: '9.5px', fontWeight: 500, paddingTop: '6px', paddingBottom: '6px', textAlign: 'left' }}>{'รวม'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, paddingTop: '6px', paddingBottom: '6px', textAlign: 'end', width: '75px' }}>{numberFormat(sum) || '-'}</td>
              </tr>
            </tbody>
          </table>
        </Box>
      </Box>
    </Box>
  )
}

export function ExportData(props: ExportProps) {
  return (
    <>
      <div className="large">{props.headCells}</div>
      {props.componant}
    </>
  )
}

export function ExportComponant({ incomeExport, incomeTypeExport, incomeOverdueExport }: any) {
  const { t } = useTranslation()
  const [snType, setSnType] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])
  // REPORT.TABLE.INCOME_DAY.PATIENT_CN_NUMBER
  const headCellIncome = [
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.BILL_ID', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.DATE_TIME', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'APPLICATION.TABLE.CELL.CN_NUMBER', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'PATIENT_MANAGEMENT.TABLE.CELL.SN_CODE', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.PATIENT_NAME', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.PATIENT_AGE', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.PAYMENT_STATUS', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.PAYMENT_CHANNELS', align: 'left', class: 'text-wrap' },
    { id: 'price', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.PAYMENT_PAY', align: 'right', class: 'text-nowrap' },
    { id: 'price', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.PAYMENT_OVERDUE', align: 'right', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.REMARK', align: 'center', class: 'text-wrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.CREATED_BY', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.REMARK_CANCEL', align: 'center', style: { width: '20px', whiteSpace: 'pre-wrap', wordWrap: 'break-word', important: true } },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.CANCEL_BY', align: 'center', class: 'text-nowrap' }
  ]
  if (!snType) {
    headCellIncome.splice(4, 1)
  }
  const headCellIncomeType = [
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.TYPE_OF_PAYMENT', align: 'left', class: 'text-nowrap' },
    { id: 'price', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME', align: 'right', class: 'text-nowrap' },
    { id: 'price', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.SUMMARY_CANCEL', align: 'right', class: 'text-nowrap' }
  ]

  const headCellIncomeOverdue = [
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.TYPE_OF_PAYMENT', align: 'left', class: 'text-nowrap' },
    { id: 'price', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.SUMMARY_INCOME', align: 'right', class: 'text-nowrap' },
    { id: 'price', disablePadding: false, labelKey: 'REPORT.TABLE.INCOME_DAY.SUMMARY_CANCEL', align: 'right', class: 'text-nowrap' }
  ]

  const renderIncomeOverdueExport = (data: any, no: number) => {
    const num = no + 1
    return (
      <TableRowExport
        key={num.toString()}
        id={no.toString()}
        obj={data}
        columns={[
          { option: 'TEXT', align: 'left', label: data.paymentChannelName || '-' },
          { option: 'TEXT', align: 'right', label: numberFormat(data.paidNormal) || '-' },
          { option: 'TEXT', align: 'right', label: numberFormat(data.paidCancel) || '-' }
        ]}
      />
    )
  }

  const renderIncomeTypeExport = (data: any, no: number) => {
    const num = no + 1
    const paymentChanel = data.paymentChannelName === 'Voucher' ? t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.VOUCHER') : data.paymentChannelName
    return (
      <>
        <TableRowExport
          key={num.toString()}
          id={no.toString()}
          obj={data}
          columns={[
            { option: 'TEXT', align: 'left', label: `${paymentChanel} ${data.cardTypeName !== null ? `(${data.cardTypeName})` : ``}` || '-' },
            { option: 'TEXT', align: 'right', label: numberFormat(data.paidNormal) || '-' },
            { option: 'TEXT', align: 'right', label: numberFormat(data.paidCancel) || '-' }
          ]}
        />
      </>
    )
  }

  const renderIncomeExport = (data: any, no: number) => {
    const num = no + 1
    const columns = [
      { option: 'TEXT', align: 'left', label: data.billNo, class: 'text-nowrap' },
      { option: 'TEXT', align: 'left', label: dateTimeToView(data.paidAt), class: 'text-nowrap' },
      { option: 'TEXT', align: 'left', label: data.cnNumber || '-', class: 'text-nowrap' },
      { option: 'TEXT', align: 'left', label: data.branchCnNumber || '-', class: 'text-nowrap' },
      { option: 'TEXT', align: 'left', label: data.snCode || '', class: 'text-nowrap' },
      { option: 'TEXT', align: 'left', label: data.patientFullname, class: 'text-nowrap' },
      { option: 'TEXT', align: 'center', label: data.age, class: 'text-nowrap' },
      { option: 'TEXT', align: 'center', label: t(`REPORT.BILL_STATUS.${data.billStatus}`), class: 'text-nowrap' },
      { option: 'TEXT', align: 'left', label: data.paymentChannel, class: 'text-nowrap' },
      { option: 'TEXT', align: 'right', label: numberFormat(data.amountPaid), class: 'text-nowrap' },
      { option: 'TEXT', align: 'right', label: numberFormat(data.overdue), class: 'text-nowrap' },
      { option: 'TEXT', align: 'center', label: data.remark, class: 'text-nowrap' },
      { option: 'TEXT', align: 'center', label: data.createdBy, class: 'text-nowrap' },
      { option: 'TEXT', align: 'center', label: data.cancelRemark, class: 'text-wrap' },
      { option: 'TEXT', align: 'center', label: data.cancelBy, class: 'text-nowrap' }
    ]
    if (!snType) {
      columns.splice(4, 1)
    }
    return (
      <>
        <TableRowExport key={num.toString()} id={no.toString()} obj={data} columns={columns} />
      </>
    )
  }

  return (
    <>
      <UseStyled.Styles className="pt-3">
        <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
          <thead>
            <tr>
              {_.map(headCellIncome, (val: any) => {
                return <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500, ...val.style }}> {t(val.labelKey)}</td>
              })}
            </tr>
          </thead>
          <tbody>
            {_.map(incomeExport, (d: any, index: number) => {
              return renderIncomeExport(d, index)
            })}
          </tbody>
        </table>
      </UseStyled.Styles>
      <br></br>
      <UseStyled.Styles className="pt-5">
        <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
          <thead>
            <tr>
              {_.map(headCellIncomeType, (val: any) => {
                return <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500 }}> {t(val.labelKey)}</td>
              })}
            </tr>
          </thead>
          <tbody>
            {[
              _.map(incomeTypeExport, (d: any, index: number) => {
                return renderIncomeTypeExport(d, index)
              })
            ]}
          </tbody>
        </table>
      </UseStyled.Styles>
      <br></br>
      <UseStyled.Styles className="pt-3">
        <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
          <thead>
            <tr>
              {_.map(headCellIncomeOverdue, (val: any) => {
                return <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500 }}> {t(val.labelKey)}</td>
              })}
            </tr>
          </thead>
          <tbody>
            {[
              _.map(incomeOverdueExport, (d: any, index: number) => {
                return renderIncomeOverdueExport(d, index)
              })
            ]}
          </tbody>
        </table>
      </UseStyled.Styles>
    </>
  )
}
